import React from 'react';
import InventorySummaryWidget from '../components/InventorySummaryWidget';
import ProductionOrdersSummaryWidget from '../components/ProductionOrdersSummaryWidget';
import { WithPermission } from '../contexts/PermissionsContext';

const Dashboard: React.FC = () => {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Dashboard</h1>
        <p className="page-subtitle">Production overview and key metrics</p>
      </div>

      {/* Dashboard Widgets Grid - Quarter page layout */}
      <div className="dashboard-widgets">
        <WithPermission permission="page.inventory">
          <div className="dashboard-widget">
            <InventorySummaryWidget />
          </div>
        </WithPermission>

        <WithPermission permission="page.production_orders">
          <div className="dashboard-widget">
            <ProductionOrdersSummaryWidget />
          </div>
        </WithPermission>
      </div>

      {/* Welcome Information */}
      <div className="card">
        <h3>Welcome to Blooms Production Management</h3>
        <p>This dashboard provides an overview of your production system:</p>
        <ul>
          <li>
            <strong>Inventory Summary:</strong> Real-time inventory status with alerts for low stock
            and expiring items
          </li>
          <li>
            <strong>Production Orders:</strong> Overview of production orders with status breakdown
            and today's scheduled orders
          </li>
        </ul>
        <p>Click on any widget to navigate to detailed views and manage your operations.</p>
      </div>
    </div>
  );
};

export default Dashboard;
